module.exports = __webpack_public_path__ + "img/case12.abf92f6a.png";